import { EmptyState } from "../ui";

/** Bereiche, die in einer späteren Etappe kommen – ohne tote Links, mit klarem Hinweis. */
export function Platzhalter({ titel, etappe }: { titel: string; etappe: string }) {
  return (
    <div className="app-zustand">
      <EmptyState illustration="empty-shelf" title={titel}>
        Dieser Bereich kommt in {etappe}. Bis dahin gibt es hier nichts zu tun.
      </EmptyState>
    </div>
  );
}
